const quickbookPaths = {
    accountReceivable: "/tms/billing/account-receivable",
    customerProfile: "/tms/customer",
    applyPayment: "/tms/billing/payment",
    dispatcherBilling: "/tms/Dispatcher/billing"
}

export default quickbookPaths;